module.exports = __webpack_public_path__ + "img/mision5.4f5e2fba.png";